import * as Assets from "../../assets";

export const EnvirotainerTimeLineIcons: Map<string, any> = new Map<string, any>([
	["Courier", Assets.Envirotainer.Courier],
	["Air", Assets.Envirotainer.AirTransport],
	["Road", Assets.Envirotainer.FrontalTruck],
	["Rail", Assets.Envirotainer.TrainFront],
	["Sea", Assets.Envirotainer.Ocean],
	["Mail", Assets.Envirotainer.Email],
	["Office", Assets.Envirotainer.Office],
	["Warehouse", Assets.Envirotainer.Warehouse],
	["Hospital", Assets.Hospital],
	["Checkpoint", Assets.Checkpoint],
	["CrossDock", Assets.Envirotainer.CrossDock],
	["Retail", Assets.Envirotainer.Retail],
	["Home", Assets.Envirotainer.Home],
	["Airport", Assets.Envirotainer.Airport],
	["Seaport", Assets.Envirotainer.Seaport],
	["Customs", Assets.Envirotainer.Customs],
]);

export const getEnvirotainerTruckIcon = (deviceId?: string): string => {
	let icon = Assets.Envirotainer.Container;

	if (deviceId?.includes("RAP")) {
		icon = Assets.Envirotainer.RAPContainer;
	}
	if (deviceId?.includes("RKN")) {
		icon = Assets.Envirotainer.RKNContainer;
	}
	if (deviceId?.includes("RLP")) {
		icon = Assets.Envirotainer.RLPContainer;
	}

	return icon;
};

